import { ReactComponent as eye } from './eye.svg';
import { ReactComponent as eyeClosed } from './eyeclosed.svg';

/**
 * How to add new icons:
 * 1. Create a new .svg file /src/assets/icons
 * 2. Paste the svg of the icon in that file
 * 3. Import the icon here using the same syntax as the existing icons
 * 4. Add the new icon to the Icon object below
 *
 * Great icon resource: [tabler icons](https://tablericons.com/)
 */

export const Icon = {
  eye,
  eyeClosed,
};
